import React from 'react';
import ReactDOM from 'react-dom';
import Hackathon from './Hackathon';
ReactDOM.render(
  <>
    <Hackathon />
  </>,
  document.getElementById('root')
);
